/**
 * What students say carousel - Swiper.js Implementation
 * Testimonial carousel with navigation arrows and pagination dots (no loop)
 */

document.addEventListener('DOMContentLoaded', function () {
  initWhatStudentsSaySwiper();
});

function initWhatStudentsSaySwiper() {
  var swiperContainers = document.querySelectorAll('.what-students-say__swiper');

  if (!swiperContainers.length || typeof Swiper === 'undefined') {
    // If Swiper is not loaded yet, retry after a short delay
    if (swiperContainers.length && typeof Swiper === 'undefined') {
      setTimeout(initWhatStudentsSaySwiper, 100);
    }
    return;
  }

  swiperContainers.forEach(function (container) {
    var wrapper = container.closest('.what-students-say__carousel-wrapper');
    var prevBtn = wrapper ? wrapper.querySelector('.what-students-say__nav--prev') : null;
    var nextBtn = wrapper ? wrapper.querySelector('.what-students-say__nav--next') : null;

    var swiper = new Swiper(container, {
      // Core settings
      effect: 'slide',
      grabCursor: true,
      loop: false,

      // Speed
      speed: 500,

      // Show 1 card with a peek of the next
      slidesPerView: 1.05,
      spaceBetween: 24,

      // Pagination dots
      pagination: {
        el: container.querySelector('.what-students-say__pagination'),
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active',
      },

      // Keyboard navigation
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },

      // Responsive breakpoints
      breakpoints: {
        // Extra small mobile
        0: {
          slidesPerView: 1,
          spaceBetween: 12,
        },
        // Mobile
        481: {
          slidesPerView: 1,
          spaceBetween: 16,
        },
        // Tablet
        769: {
          slidesPerView: 1.05,
          spaceBetween: 20,
        },
        // Desktop
        1200: {
          slidesPerView: 1.05,
          spaceBetween: 24,
        },
      },

      // Accessibility
      a11y: {
        prevSlideMessage: 'Previous testimonial',
        nextSlideMessage: 'Next testimonial',
      },
    });

    // Wire up custom navigation buttons
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        swiper.slidePrev();
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        swiper.slideNext();
      });
    }

    // Update disabled state on navigation buttons
    function updateNavButtons() {
      if (prevBtn) {
        prevBtn.disabled = swiper.isBeginning;
      }
      if (nextBtn) {
        nextBtn.disabled = swiper.isEnd;
      }
    }

    // Initial state
    updateNavButtons();

    // Update on slide change
    swiper.on('slideChange', updateNavButtons);
    swiper.on('reachBeginning', updateNavButtons);
    swiper.on('reachEnd', updateNavButtons);
  });
}
